import React from 'react';
import SEO from '../components/SEO';
import ServicesHero from '../components/services/ServicesHero';
import ServicesList from '../components/services/ServicesList';
import ServicesProcess from '../components/services/ServicesProcess';
import ServicesWhyChoose from '../components/services/ServicesWhyChoose';

const Services: React.FC = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Services"
        description="Documentary production, branding, events coverage, photography, social media, and project documentation. See how Bizani Media brings your story to life."
        path="/services"
        keywords="video production, film production, branding, events coverage, photography, social media, project documentation, Zimbabwe media, corporate videos, documentary production"
      />
      <ServicesHero />
      <ServicesList />
      <ServicesProcess />
      <ServicesWhyChoose />
    </div>
  );
};

export default Services;
